import { render, staticRenderFns } from "./email-template-staging-widget.vue?vue&type=template&id=6e7b45e1&"
import script from "./email-template-staging-widget.vue?vue&type=script&lang=js&"
export * from "./email-template-staging-widget.vue?vue&type=script&lang=js&"
import style0 from "./email-template-staging-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports